/* unplugin-vue-components disabled */import { render } from "./pulse-empty.vue?vue&type=template&id=530a394f&scoped=true"
import script from "./pulse-empty.vue?vue&type=script&lang=js"
export * from "./pulse-empty.vue?vue&type=script&lang=js"

import "./pulse-empty.vue?vue&type=style&index=0&id=530a394f&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-530a394f"],['__file',"src/pages/pulse/pulse-empty.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "530a394f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('530a394f', __exports__)) {
    api.reload('530a394f', __exports__)
  }
  
  module.hot.accept("./pulse-empty.vue?vue&type=template&id=530a394f&scoped=true", () => {
    api.rerender('530a394f', render)
  })

}


export default __exports__